module.exports = __webpack_public_path__ + "static/media/devscolaLogo.1f6d6caf.png";